import { render, staticRenderFns } from "./AssessmentBuildingsPopUp.vue?vue&type=template&id=35e220ca&scoped=true"
import script from "./AssessmentBuildingsPopUp.vue?vue&type=script&lang=js"
export * from "./AssessmentBuildingsPopUp.vue?vue&type=script&lang=js"
import style0 from "./AssessmentBuildingsPopUp.vue?vue&type=style&index=0&id=35e220ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e220ca",
  null
  
)

export default component.exports